import { useFormStore } from "../stores/form-store";

export function useForms() {
	const forms = useFormStore((store) => store.forms);
	const presets = useFormStore((store) => store.presets);
	const showForm = useFormStore((store) => store.show);
	const indexForms = useFormStore((store) => store.index);
	const createForm = useFormStore((store) => store.create);
	const updateForm = useFormStore((store) => store.update);
	const deleteForm = useFormStore((store) => store.delete);
	const cloneForm = useFormStore((store) => store.clone);
	const listPresets = useFormStore((store) => store.listPresets);

	return {
		forms,
		presets,
		showForm,
		indexForms,
		createForm,
		updateForm,
		deleteForm,
		cloneForm,
		listPresets,
	};
}
